import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ILifeEvent, LifeEvent } from '../LifeEvent.ts';
import { LifeEventsApi } from '../../../apis/LifeEventsApi/LifeEventsApi.ts';

export function usePutLifeEventMutations() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [QueryKeys.lifeEvents, QueryKeys.lifeEvent],

        mutationFn: async ({ id, lifeEvent }: { id: string; lifeEvent: ILifeEvent }) => {
            await LifeEventsApi.putLifeEvent(id, lifeEvent);
            return lifeEvent;
        },

        onSuccess: (data: ILifeEvent) => {
            queryClient.setQueryData<LifeEvent[]>([QueryKeys.lifeEvents], (prev) => {
                if (!prev) return [];
                return prev.map((event) => (event.id === data.id ? new LifeEvent(data) : event));
            });
            queryClient.setQueryData<LifeEvent>([QueryKeys.lifeEvent, data.id.toString()], () => {
                return new LifeEvent(data);
            });
        },
    });
}
